import React, { useState } from 'react';

import { InputReg } from '@interlayer/js/app/components/main/Registration/components/common/InputReg';
import { TooltipPassword } from '@interlayer/js/app/components/main/Registration/components/common/TooltipPassword';

import { VALIDATION_FIELDS } from '@interlayer/js/app/hooks/useValidationRules/constants';

const PIN_CRITERIA = Array.from({ length: 4 }, (_, index) => `pin_criteria_${index}`);

export const PinFields: React.FC = () => {
    const [isShowTooltip, setIsShowTooltip] = useState(false);

    const handlerShowTooltip = (isShow: boolean) => () => {
        setIsShowTooltip(isShow);
    };

    return (
        <>
            <div>
                <InputReg
                    name={VALIDATION_FIELDS.pinReg}
                    type="password"
                    pattern="\d*"
                    inputMode="numeric"
                    autoComplete="new-pinReg"
                    onFocus={handlerShowTooltip(true)}
                    onBlur={handlerShowTooltip(false)}
                />

                <TooltipPassword
                    isDefaultIcon
                    titleKey="pin_criteria_title"
                    criteria={PIN_CRITERIA}
                    isShow={isShowTooltip}
                />
            </div>

            <InputReg
                isDisabledCopyPast
                name={VALIDATION_FIELDS.confirmPinReg}
                type="password"
                pattern="\d*"
                inputMode="numeric"
                autoComplete="new-confirmPinReg"
            />
        </>
    );
};
